export enum ApiPaths {

  //COMMON
  getPicklistByCategoryId = '/picklist/',//{categoryId}
  getAllPicklistCategories = '/picklistCategories',
  getPicklistByUiField = '/pickListDetails/',//{uiFieldGroup}
  getCurrentWeekendingDt = '/getCurrentWED',
  getProductionEntities = '/getAllProductionEntityList',
  
  //PROJECT
  getProjects = '/projects',
  getProjectById = '/project/',//{projectId}
  saveProject = '/saveProjectDetails',
  updateProject = '/updateProjectDetails',
  searchProject = '/searchTitle',
  changeProjectStatus = '/initiateProjectStatusChangeover',
  psrReport = '/main/generateSingleReports',
  copyPostProductionSchedulesToActualsForWED = '/copyPostProductionSchedulesToActualsForWED',
  deleteProject = '/changeDeleteFlag',
  checkIfBudgetPresentByProject = '/checkIfBudgetPresentByProject',

  //RECENT SEARCH
  getRecentlyViewedTitlesByUser = "/getRecentlyViewedTitlesByUser",
  // saveRecentViewedTitles = "/saveRecentViewedTitles",
  
  //REPORT HEADER
  getReportHeader = '/headerTextByProjectIdAndWeekendingDt',
  updateReportHeader = '/saveHeaderText',

  //KEY CREW
  getKeyCrew = '/getTalentsByProject',
  saveKeyCrew = '/saveTalentDetails',

  //KEY DATES
  getKeyDates = '/getPostProdSchedByProjectAndWeekendingDt',
  saveKeyDates = '/savePostProductionDetails',

  //SCHEDULE
  getSchedule ="/scheduleLocationDataByProject",
  saveSchedule ="/saveLocationsDetails",

  //NET POTENTIAL
  getNetPotential = '/potentialDataByProject',
  saveNetPotential = '/savePotentials',
  deleteNetPotential = '/deletePotentialById',

  //NET COST SUMMARY
  getNetCostSummary='/getTotalNetCostSummary',
  saveChangePrior='/saveChangePriorDetails',
  saveCumulative='/saveCumulativeDetails',
  deleteCumulative='/deleteCumulativeById',
  deleteChangePrior='/deleteChangePriorById',
  deleteAllChangePrior='/deleteAllChangePrior',

  //KEY ISSUES
  getKeyIssues = '/keyIssuesNotesByProject',
  saveComments = '/saveKeyIssuesDetails',
  saveTaxCredits = '/saveTaxCredit',
  getProjectAka = '/getTitlesByProject',
  saveProjectAka = '/saveProjectAka',
  deleteProjectAka = '/deleteProjectAkaById',
  addProductionEntity = '/saveProductionEntity',
  //updateProjectFieldsForProdAdmin= '/updateProjectFieldsForProdAdmin',

  //PRE PRODUCTION BUDGET
  getPreProdBudget = '/preProdBudgetDetailsByProjectAndWeekEnding',
  savePreProdBudget = '/savePreProdDetails',
  lockPreProdBudget = '/lockingBudgetandLocationDetails',

  //PRODUCTION BUDGET
  getBudget = '/budgetDataOnProjectAndWeekEnding',
  saveBudget = '/saveBudgetDetails',
  updateBudgetFieldsForFinanceUser = '/updateBudgetFieldsForFinanceUser',

  //WEEKLY VARIANCE
  getWeeklyVariance = '/weeklyVarianceDataByProjectAndWeekEnding',
  getAccountMasterList = '/getAllAccountData',
  saveWeeklyVariance = '/saveWeeklyVarianceDetails',
  deleteWeeklyVariance = '/deleteWeeklyVarianceById',
  generateWeeklyVarianceHistory = '/weeklyHistory/',

  //SYSTEM ADMIN
  getRollbackStatus = '/checkRollbackStatus',
  weekendRollBack = '/initiateWeekendingRollback',
  weekendRollForward = '/initiateWeekendingRollForward',

  //AUDIT REPORTS
  getPublishHistory = '/getPublishHistoryReport',
  getActitvityData = '/fetchAppAuditLogs',
  

  //GENERATE REPORT
  generateAdHocPSRReport = '/generateAdHocPSRReport',
  generateWeeklyVarianceReport = '/generateWeeklyVarianceReport',
  generateMultiPPSRReport = '/generateMultiPPSRReport',

  //PICKLIST ADMIN
  pickListDetails = '/pickListDetails',
  picklist = '/picklist',
  picklistDetailsByCategory = '/picklistDetailsByCategory',
  saveOrUpdatePicklistDetail = "/saveOrUpdatePicklistDetail",
  saveOrUpdateVendor = "/saveOrUpdateVendor",
  getVendorsForPicklist = "/getVendorsForPicklist",

  
  //SEARCH    
  searchTitleByParams = '/searchTitleByParams',

  
  //POST PRODUCTION  
  getVendors = '/getVendors',
  getTalents = '/getTalents',
  addPostProdTalent = '/addPostProdTalent',
  getProjectPostProdDetails = '/getProjectPostProdDetails',

  //POST STUDIO PRODUCTION
  getPostStudioProduction = '/getPostStudioProduction',
  savePostStudioProduction = '/savePostStudioProduction',
  deletePpsrDealManager = '/deletePpsrDealManagerById', //dealId

  
  //FILM DETAILS & POST FACILTIES
  getCameraAndEditorLocation = '/getCameraAndEditorLocationByProject',
  savePostProdProjectDetails = '/saveFilmDetailsAndPostFacility',
  saveCameraDetails = '/saveCameraDetailsByProject',
  deleteCameraDetails = '/deleteCameraDetailsById',
  saveEditorialLocations = '/saveEditorialLocations',
  deleteEditorialLocations = '/deleteEditorialLocationById',
  getRuntimeDetails = '/getRuntimeDetails',

  
  //POST SCHEDULE KEY INFO
  getPostProdSchedDetailsInKeyInfo = '/getPostProdSchedDetailsInKeyInfo',
  savePostProdSchedDetailsInKeyInfo = '/savePostProdSchedDetailsInKeyInfo',
  updateProjectFlags = '/updateFlagsByProjectAndWed',

  //POST COMMENTS
  getPostComments = '/getPostComments',
  savePostComments = '/savePostComments',


  //POST PRODUCTION SCHEDULE
  getAllActivityList = '/getAllActivityList',
  getPostProdActivityScheduleData = '/getPostProdActivitySched',
  savePostProdActivityScheduleData = '/savePostProdActivitySched',
  getInterplanFeedForPPSR ='/getInterplanFeedForPPSR/', //projectId
  
  // getAllEfcAmountsByWeekendingDate = '/fetchAllEfcAmountsWeekendingDt',
  // getAccountDataBycategory = '/accountDataBasedOnCategory/',


 

  //Admin Module APIs
  getRoles = '/roles',
  getScreens = '/screens',
  getUsersByPSRGroup = '/usersByGroup',
  getUserDetailBySpeId = '/userDetailBySpe',
  createProject = '/createProjectDetails',
  searchIDMUserDetailsByUserId='/searchIDMUserDetailsByUserId',

  checkPublishStatus = '/checkPubStatusForCurrentWED',
  getAllActiveUsers = '/getAllActiveUsers',
  getAllPSRGroups = '/getAllUserGroups',
  getAllPublishedGroups = '/getAllPublishedGroups',
  revokePsrAccess = '/revokePsrAccess',

  lastAccessedByReport = '/getLastAccessedByReport',

  getUserRoleAndPermissions = '/getPermissionsAndRolesByUser',
  getPermissionsByRole = '/getPermissionsByRoles',
  
  saveProjectDetails = '/saveProjectDetails',
  getAllPublishPSRGroups = '/getAllPublishedGroups',
  publishWeeklyPSRReports = '/publishWeeklyPSRReports',
  revokePSRGroups = '/revokePsrAccess',
  createAuthorizationToken = '/createAuthorizationToken',
  refreshAuthToken = '/refreshAuthToken',

  getUserDetails = '/getUserDetails',
  isIDMSessionActive = '/isIDMSessionActive',
  deleteUser='/deleteUser',
  saveUser='/saveUser',
  getChangePriorTrackerInfo = '/getAllBudgetUpdateInfo',

  //MANAGE RELEASE DATES
  getAllUnSynchedInterplanTitles= "/getAllUnSynchedInterplanTitles",
  updateViewFlagForInterplanTitles= "/updateViewFlagForInterplanTitles",
  syncInterplanReleaseDateToPPSR= "/syncInterplanReleaseDateToPPSR",

  //LAS SAP
  getLasSapRecords = "/getLasSapRecords",
  updateLasSapRecords = "/updateProjectLasDetails",

  checkIfUserIsAssociatedToPsrGroup = "/checkIfUserIsAssociatedToPsrGroup",

  //MANAGE PSR USER GROUP
  getAllUserGroups="/getAllUserGroups",
  saveUserGroupDetails="/saveUserGroupDetails",
  deleteUserFromGroup="/deleteUserFromGroup",
  getAllUsersWithGroups="/getAllUsersWithGroups",

  //MANAGE PRODUCTION ENTITIES
  getProductionEntityList="/getProductionEntityListWithProjectDetails",
  updateProductionEntity="/updateProductionEntity",
  softDeleteProdEntity="/changeDeleteFlagForEntity",
  doesEntityHaveProject="/checkIfEntityHaveProject",

  saveProjectCreativeExecutiveDetails="/saveProjectCreativeExecutiveDetails",
  deleteProjectCreativeExecutiveByID="/deleteProjectCreativeExecutiveByID",


  //REDIRECT USER TO RECENT REPORT
  getDistroUserUuid="/getDistroUserUuid"

}